"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var DateTimeCheckService_1 = __importDefault(require("../DateTimeCheckService"));
var GenerationService = (function () {
    function GenerationService() {
    }
    GenerationService.arrangeContentBlocksByTime = function (contentBlocks, nextTime) {
        var filteredBlocks = contentBlocks.filter(function (block) {
            return DateTimeCheckService_1.default.checkNextTimeForObject(block, nextTime);
        });
        var specialBlocks = filteredBlocks.filter(function (block) { return block.isSpecial; });
        return specialBlocks.length ? specialBlocks : filteredBlocks;
    };
    GenerationService.correctMarks = function (playlistItems) {
        return playlistItems.map(function (item, index) {
            var nextItem = playlistItems[index + 1];
            var calcDuration;
            if (nextItem && nextItem.type != 0 && item.type === 0) {
                calcDuration = (0, moment_timezone_1.default)(nextItem.playtime).diff(item.playtime, "seconds");
            }
            return __assign(__assign({}, item), { cueOut: calcDuration ? calcDuration + item.cueIn : item.cueOut, startNext: calcDuration ? calcDuration : item.startNext });
        });
    };
    GenerationService.postProcessingMarksForRotations = function (rotations) {
        return rotations.map(function (r, index) {
            var nextRotation = rotations[index + 1];
            if (nextRotation && nextRotation.mediafile.type != 0 && r.mediafile.type == 0) {
                var calcDuration = (0, moment_timezone_1.default)(nextRotation.playtime).diff(r.playtime, "seconds");
                var cueOut = calcDuration + r.mediafile.cueIn;
                return __assign(__assign({}, r), { mediafile: __assign(__assign({}, r.mediafile), { cueOut: cueOut, startNext: calcDuration }) });
            }
            return r;
        });
    };
    GenerationService.getMediafilesForBlocks = function (contentBlocks, mediafiles, mediafileBlockPattern, silentMediafile, dislikedMediafiles) {
        if (!(contentBlocks === null || contentBlocks === void 0 ? void 0 : contentBlocks.length)) {
            return [silentMediafile];
        }
        var temporaryContentBlockIds = contentBlocks.map(function (block) { return block.id; });
        var filteredMediafileIds = mediafileBlockPattern
            .filter(function (mediafileBlock) { return temporaryContentBlockIds.includes(mediafileBlock[1]); })
            .map(function (mediafileBlock) { return mediafileBlock[0]; });
        return mediafiles.filter(function (mediafile) {
            return filteredMediafileIds.includes(mediafile.id) && !dislikedMediafiles.includes(mediafile.id);
        });
    };
    GenerationService.getLastMediafileIds = function (lastRotations, oneToOneSeparate, generationResult) {
        var indexHistory = Math.max.apply(null, [0, oneToOneSeparate - generationResult.length]);
        var mediafileIdsFromHistory = lastRotations
            .slice(0, indexHistory)
            .map(function (r) { var _a; return ((_a = r.mediafile) === null || _a === void 0 ? void 0 : _a.id) || r.mediafileId; });
        var mediafileIdsFromResult = generationResult.slice(0, oneToOneSeparate).map(function (r) { return r.id; });
        return __spreadArray(__spreadArray([], __read(mediafileIdsFromHistory), false), __read(mediafileIdsFromResult), false);
    };
    GenerationService.lastResultSort = function (lastRotations) {
        return lastRotations.sort(function (a, b) { return (a.playtime < b.playtime ? -1 : 1); });
    };
    GenerationService.getMediafileSortFunc = function (oneToOneSeparate, lastRotations, rotatedMediafiles, generationResult) {
        var _this = this;
        return function (a, b) {
            var _a, _b;
            var lastMediafileIds = _this.getLastMediafileIds(lastRotations, oneToOneSeparate, generationResult);
            var firstIncluded = lastMediafileIds.includes(a.id);
            var secondIncluded = lastMediafileIds.includes(b.id);
            if (firstIncluded !== secondIncluded) {
                return !firstIncluded && secondIncluded ? -1 : 1;
            }
            var firstRotated = (_a = rotatedMediafiles[a.id]) !== null && _a !== void 0 ? _a : 0;
            var secondRotated = (_b = rotatedMediafiles[b.id]) !== null && _b !== void 0 ? _b : 0;
            if (firstRotated !== secondRotated) {
                return firstRotated < secondRotated ? -1 : 1;
            }
            var items = [-1, 1];
            return items[Math.floor(Math.random() * items.length)];
        };
    };
    GenerationService.excludeMostPlayedMediafiles = function (mediafiles, rotatedMediafiles) {
        var copy = __spreadArray([], __read(mediafiles), false);
        copy.sort(function (prev, next) {
            var _a, _b;
            var prevPlayed = (_a = rotatedMediafiles[prev.id]) !== null && _a !== void 0 ? _a : 0;
            var nextPlayed = (_b = rotatedMediafiles[next.id]) !== null && _b !== void 0 ? _b : 0;
            return prevPlayed - nextPlayed;
        });
        return copy.slice(0, Math.round(copy.length * 0.9));
    };
    GenerationService.getFilteredBlockPattern = function (contentBlocks, blockPattern) {
        var contentBlockIds = contentBlocks.map(function (block) { return block.id; });
        return blockPattern.filter(function (pattern) { return pattern.filter(function (p) { return contentBlockIds.includes(p); }); });
    };
    return GenerationService;
}());
exports.default = GenerationService;
//# sourceMappingURL=index.js.map